import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { TranslationKeys } from '../../../enums';
import { OddsContent } from '../../../conatiners/common/popUps/gameSpecificPopupContents';

export const HelpPopUp = observer(() => {
  const t = useTranslation();
  return (
    <div className='result-content-b'>
      <div className='fs-help-popup-text'>
        <p>{t(TranslationKeys.GameRulesP1)}</p>
        <p>{t(TranslationKeys.GameRulesP2)}</p>
        <p>{t(TranslationKeys.GameRulesP3)}</p>
        <p>{t(TranslationKeys.GameRulesP5)}</p>
        <p>{t(TranslationKeys.GameRulesP6)}</p>
        <p>{t(TranslationKeys.GameRulesP7)}</p>
        <p>{t(TranslationKeys.GameRulesP8)}</p>
        {/* <p>{t(TranslationKeys.GameRulesP9)}</p> todo check with PM */}

        <p>{t(TranslationKeys.GameRulesP4)}</p>
        <OddsContent t={t} />
        <p>{t(TranslationKeys.GameRulesP16)}</p>
        <p>{t(TranslationKeys.GameRulesP17)}</p>
        <p>{t(TranslationKeys.GameRulesP18)}</p>
        <p>
          {t(TranslationKeys.CancelationMessage1)}
          <br />
          {t(TranslationKeys.MalfunctionMessage2)}
        </p>
        <p className={'rtp'}>{t(TranslationKeys.Rtp)}</p>
      </div>
    </div>
  );
});
